<script setup lang="ts">
/**
 * Translations.
 */
const { t } = useI18n()

/**
 * Use query params.
 */
const { config, options } = useParams()

/**
 * Use framework.
 */
const { isPrevalence } = useFramework()

/**
 * Show or hide the button.
 */
const show = computed(() => {
    return (
        isPrevalence(config.dimension) || isPrevalence(config.compareDimension)
    )
})
</script>

<template>
    <UiSelect
        v-if="show"
        v-model="config.prevalenceUnit"
        :options="options.prevalenceUnits"
        :label="t('prevalence-unit')"
        data-tutorial-step="10"
        :data-tutorial-text="t('tutorial-prevalence-unit')"
        direction="top"
        class="flex-shrink-0"
    />
</template>